<template>
  <div class="wrapper-survey p-5 mb-6">
    <div>
      <p class="averta-bold is-size-4">Review Penawaran Baru Dari Konsultan</p>
      <p>Segera review detail penawaran yang telah dibuat oleh konsultan sebelum dilanjutkan ke client</p>
    </div>
    <div class="columns mt-3 parrent-list pb-3">
      <div class="column card list-survey is-4 p-5 m-2 is-clickable is-flex is-flex-direction-column" v-for="data, index in dataPenawaranWaiting" :key="`card-review-${index}`" @click="goToProject(data.survey_id)">
        <div class="columns card-atas pb-2 is-flex-grow-1 mb-0">
            <div class="column">
                <p>{{ data.survey_complain_code ? data.survey_complain_code : data.survey_id }}</p>
                <p class="store averta-bold">{{ data.store.name }}</p>
            </div>
            <div class="column has-text-centered">
                <p class="px-3 py-1 status-survey mb-3" :class="getClassName(data.status)">{{ data.status }}</p>
                <div class="flex-center-horizontal">
                  <div class="img-vendor mr-2">
                    <img :src="data.vendor.logo" :alt="data.vendor.name">
                  </div>
                  <p class="averta-bold">{{ data.vendor.name }}</p>
                </div>
            </div>
        </div>
        <div class="columns card-bawah mt-4">
            <div class="column">
                <p class="mb-2">Konsultan (Survey)</p>
                <p class="averta-bold">{{ data.pic.name }}</p>
                <p class="store"><b-icon icon="whatsapp" custom-size="default"/>{{ renderPhoneNumber(data.pic.phone) }}</p>
            </div>
            <div class="column">
                <p class="mb-2">Tanggal Survey</p>
                <p class="averta-bold">{{ convertDate(data.date) }}</p>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getStatusClassName } from '@/helpers'

export default {
  name: 'CardReviewOffering',
  props: ['dataPenawaranWaiting'],
  computed: {
    currentPath () {
      const path = this.$route.path.split('/')
      console.log(path)
      const firstElement = path[1]

      return firstElement
    }
  },
  methods: {
    convertDate (date) {
      return moment(date).format('DD MMMM YYYY')
    },
    goToProject (id) {
      if (this.currentPath === 'am') {
        this.$router.push('/am/project')
      } else if (this.currentPath === 'sm') {
        this.$router.push(`/sm/project/survey/${id}/detail`)
      } else if (this.currentPath === 'purchasing') {
        this.$router.push('/purchasing/project')
      } else {
        this.$router.push(`/project/survey/${id}/detail`)
      }
    },
    renderPhoneNumber (phone) {
      if (phone) {
        if (phone.toString().substring(0, 2) === '62') {
          return `+${phone}`
        } else {
          return `+62${phone}`
        }
      } else {
        return ''
      }
    },
    getClassName (status) {
      return getStatusClassName(status)
    }
  },
  mounted () {
    // console.log(this.dataPenawaranWaiting)
  }
}
</script>

<style lang="scss" scoped>
.wrapper-survey {
    background: #FAFAFA;
}
.card {
  box-shadow: none;
}

.store {
    color: #D9272D;
}

.status-survey {
    border-radius: 20px;
    color: white;
    white-space: nowrap;
}

.card-atas {
    border-bottom: 2px dashed #868686;
}

.card-bawah {
    background: linear-gradient(90deg, rgba(255, 221, 221, 0.4) 0%, rgba(255, 239, 219, 0.4) 99.97%);
    border-radius: 12px;
}

.parrent-list {
    overflow-x: auto;
}
.list-survey {
    background: white;
}
</style>
